<template>
  <button type="button" class="address-item dangerous-good-item">
    <div class="clearfix">
      <div class="float-left col-23" v-if="dangerousGood">
        {{ dangerousGood.name }}
        <span class="text-muted"
          >({{ dangerousGood.unDetails.substring(0, 80) }})</span
        >
      </div>

      <div
        v-if="dangerousGood"
        class="d-inline text-muted float-right col-1 text-center pr-1"
        @click.prevent="$emit('showForm', dangerousGood)"
      >
        <i class="far fa-edit"></i>
      </div>

      <div class="float-left" v-if="!dangerousGood">
        Select one
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: "un-selector-item",
  props: ["dangerousGood", "newdangerousGood"],

  mounted() {
    if (this.newdangerousGood) {
      $emit("showForm", newdangerousGood);
      console.log(this.newdangerousGood);
    }
  }
};
</script>
